import{rawValueToFileType as e}from"../../../../domain/enums/FileType/FileType.enum.mjs";class i{constructor(e,i){this.fileType=e,this.fileName=i}static fromVo(m){return new i(e(m.fileType),m.fileName)}}export{i as OutputFileModel};
